'use client';

import { useSearchParams } from 'next/navigation';

import type { FilterGroupEntity } from '../../../domain';
import { FilterChip } from '../../atoms/filter-chip/filter-chip';
import type { FilterChipsGroupProps } from './filter-chips-group.types';

function findFilters({
  searchParams,
  filterGroups,
}: {
  searchParams: URLSearchParams;
  filterGroups: FilterGroupEntity[];
}) {
  const filters = [];
  const entries = Array.from(searchParams.entries());

  for (let i = 0; i < entries.length; i += 1) {
    const [key, value] = entries[i];
    const foundGroup = filterGroups.find((group) => group.key === key);
    const foundFilter = foundGroup?.items.find(
      (filter) => filter.value === value,
    );

    if (foundGroup && foundFilter) {
      filters.push({
        name: foundGroup.key,
        value: foundFilter.value,
        label: foundFilter.label,
      });
    } else if (foundGroup) {
      filters.push({
        name: foundGroup.key,
        value,
      });
    }
  }

  return filters;
}

/**
 * Renders all applied filters from url search params
 */
export function FilterChipsGroup({
  filterGroups,
  label,
}: FilterChipsGroupProps) {
  const searchParams = useSearchParams();
  const filters = findFilters({ searchParams, filterGroups });

  if (filters.length === 0) {
    return null;
  }

  return (
    <div className="flex flex-wrap items-center gap-16-16">
      {label}
      <div className="flex flex-wrap gap-8-8">
        {filters.map((filter) => (
          <FilterChip
            key={`${filter.name}-${filter.value}-filter-chip`}
            filter={filter}
          />
        ))}
      </div>
    </div>
  );
}
